import showAsUnavailable from './showAsUnavailable';
import showAsExpired from './showAsExpired';
import showAsExpiredBeforeCampaignStart from './showAsExpiredBeforeCampaignStart';

const isUnavailableThumbnailContainer = (bannerSet, allowUnavailability, campaignStartDate) =>
  showAsUnavailable(bannerSet, allowUnavailability) ||
  (!!campaignStartDate && (showAsExpired(bannerSet) || showAsExpiredBeforeCampaignStart(bannerSet, campaignStartDate)));

export default isUnavailableThumbnailContainer;
